"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachMixed = function SvgBeachMixed(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.938 4.078a1.114 1.114 0 1 0 0-2.228 1.114 1.114 0 0 0 0 2.228Zm-4.71 4.338c1.87-1.56 3.396-3.54 1.756-5.505-1.097-1.317-3.862-.818-5.73.74-1.867 1.56-2.833 3.486-1.4 5.202 1.483 1.78 3.506 1.122 5.375-.437Zm4.367 4.117c2.004-2.68 4.529-5.344 6.444-4.307 1.92 1.04 3.823 3.343 1.114 8.618-1.546 3.006-4.112 3.974-6.046 3.269-2.627-.96-3.516-4.899-1.512-7.58Zm-.733 8.918c.409-1.075-.769-3.298-2.559-4.23-.153-.08-.3-.16-.445-.237-1.544-.828-2.618-1.403-3.791.852-.642 1.232-.359 2.68 1.431 3.612 1.79.932 4.939 1.118 5.364.003Zm-8.553-5.26a1.114 1.114 0 1 1-2.228 0 1.114 1.114 0 0 1 2.228 0Zm-.58-5.092a1.114 1.114 0 1 1-2.229 0 1.114 1.114 0 0 1 2.228 0Zm5.706 4.616a1.114 1.114 0 1 0 0-2.228 1.114 1.114 0 0 0 0 2.228Zm-1.73-3.027a1.114 1.114 0 1 1-2.229 0 1.114 1.114 0 0 1 2.229 0Zm6.98-5.393a1.114 1.114 0 1 0-.001-2.229 1.114 1.114 0 0 0 0 2.229ZM19.71 5.52a1.114 1.114 0 1 1-2.229 0 1.114 1.114 0 0 1 2.229 0Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachMixed);
var _default = exports["default"] = Memo;